<div class="modal-dialog ai-markers-dialog-container">
	<div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
		<div class="goreact-modal-header">
			<span class="header-label">
				<h1 [id]="dialogTitleId" class="modal-title">
					<i class="ficon-sparkles-solid" aria-hidden="true"></i>
					<span translate="chart_title-ai_prompt"></span>
				</h1>
			</span>
      <button type="button" class="close-btn" (click)="cancel()"
        attr.aria-label="{{ 'common_close' | translate }}">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <section>
      @if (!aiConfigFlag) {
        <div class="goreact-modal-body old-style" [ngClass]="{ 'collapsed': (showAi$ | async) === false }">
          <div>{{ 'activity-editor-new_ai-markers-modal-sub-title' | translate }}</div>
          @if (aiLanguageFlag) {
            <hr/>
          }
          @if (aiLanguageFlag) {
            <div class="section-container transcript-container">
              <div class="container-header">
                <strong>{{ 'feedback-session-feedback-display_transcript-header' | translate }}</strong>
              </div>
              <span class="transcript-language">
                <span
                  class="language-label"
                  translate="activity-editor-new_ai-markers-modal-transcript-language">
                </span>
                <mat-form-field goSelect>
                  <mat-select
                    disableOptionCentering
                    panelClass="offsetPanel"
                    class="language-selector"
                    [ngModel]="selectedLanguage$ | async"
                    (ngModelChange)="selectedLanguage$.next($event)">
                    @for (language of languages$ | async; track language) {
                      <mat-option
                        [value]="language">
                        {{ language.language_name }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
                </mat-form-field>
              </span>
            </div>
          }
          @if ((loading$ | async) === false) {
            <div class="section-container markers-container"
              [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit}">
              <div class="container-header">
                <strong id="ai-markers-heading">{{ 'activity-editor-new_ai-markers-modal-ai-markers' | translate }}</strong>
                <div *teaseWall="toggleTeaseConfig; of: loading$">
                  <mat-slide-toggle
                    [hideIcon]="true"
                    (change)="toggleAiMarkers($event)"
                    [checked]="true"
                    aria-labelledby="ai-markers-heading"
                    [goAriaPressed]="(showAi$ | async)"
                    color="primary"
                    class="ai-comments-toggle">
                    @if (showAi$ | async) {
                      <span>{{ 'common_on' | translate }}</span>
                    }
                    @if ((showAi$ | async) === false) {
                      <span>{{ 'common_off' | translate }}</span>
                    }
                  </mat-slide-toggle>
                </div>
              </div>
              <p translate="activity-editor-new_ai-markers-modal-description"
                [translateParams]="{ limit: AiMarkersLimit }">
              </p>
              @if (showAi$ | async) {
                @if (useTypes$ | async) {
                  <div class="use-types-container">
                    <mat-form-field goSelect>
                      <mat-label>{{ 'activity-editor-new_ai-markers-modal-use-type' | translate }}</mat-label>
                      <mat-select
                        disableOptionCentering
                        panelClass="offsetPanel"
                        [ngModel]="useTypeFilter$ | async"
                        (selectionChange)="useTypeFilter$.next($event.value)">
                        @for (u of useTypes$ | async; track u) {
                          <mat-option
                            [value]="u.use_type_id">
                            {{ u.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
                    </mat-form-field>
                    @if ((selectedCount$ | async) > 0) {
                      <span class="selected-count"
                      role="img"
                      [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit }"
                      [attr.aria-label]="selectedCountAriaLabel((selectedCount$ | async))">({{ selectedCount$ | async }})</span>
                    }
                  </div>
                }
                <div class="markers" [style.overflow-y]="shouldTease ? 'hidden':'auto'">
                  @for (prompt of filteredPrompts$ | async; track prompt) {
                    <div class="marker-item">
                      @if (!shouldTease) {
                        <mat-checkbox
                          color="primary"
                          [checked]="(checkedIds$ | async).has(prompt.id)"
                          (change)="selectPrompt($event.checked, prompt)"
                          (keydown)="handlePromptCheckboxKeydown($event)"
                          aria-label="{{ markerAriaLabel(prompt) }}">
                          <marker
                            [marker]="markerInput(prompt)"
                            [aiStyle]="true"
                            [withName]="true">
                          </marker>
                          <div class="prompt-description">{{ prompt.description }}</div>
                        </mat-checkbox>
                      }
                      @if (shouldTease) {
                        <div class="teased-marker-item">
                          <div *teaseWall="checkboxTeaseConfig; of: loading$">
                            <mat-checkbox
                              color="primary"
                              class="checkbox-to-blur"
                              [checked]="(checkedIds$ | async).has(prompt.id)"
                              [disabled]="true"
                              aria-label="{{ markerAriaLabel(prompt) }}">
                            </mat-checkbox>
                          </div>
                          <div class="marker-and-description">
                            <marker
                              [marker]="markerInput(prompt)"
                              [aiStyle]="true"
                              [withName]="true">
                            </marker>
                            <div class="prompt-description">{{ prompt.description }}</div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (!shouldTease) {
                  <div class="ai-marker-form-link">
                    <span>
                      <i class="ficon-lightbulb-o"></i>
                      {{ 'activity-editor-new_ai-markers-modal-request-feedback-text' | translate }}
                      <a
                        href="https://forms.office.com/Pages/ResponsePage.aspx?id=pc7Ek96TuEyKKMAbn5USrIoKGA0eaHdEmMM7pLelNidUOVIwV1NKRlE3TFIxWVI1QTA1OVJROUg3Ni4u"
                        target="_blank" rel="noopener noreferrer"
                        class="link-btn"
                        attr.aria-label="{{'activity-editor-new_ai-markers-modal-request-feedback-link'| translate}}"
                        translate="activity-editor-new_ai-markers-modal-request-feedback-link">
                      </a>
                    </span>
                  </div>
                }
              }
            </div>
          } @else {
            <span class="loading-container">
              <span class="ficon-spinner ficon-spin" aria-live="polite"
              attr.aria-label="{{'common_loading'| translate}}"></span>
            </span>
          }
          @if ((selectedCount$ | async) > AiMarkersLimit) {
            <div class="validation-error"
              translate="activity-editor-new_ai-markers-modal-validation-max_limit"
              [translateParams]="{ limit: AiMarkersLimit }">
            </div>
          }
        </div>
      } @else {
        <div class="goreact-modal-body new-style" [ngClass]="{ 'collapsed': (showAi$ | async) === false }">
          <div>{{ 'activity-editor-new_ai-markers-modal-sub-title' | translate }}</div>
          @if (aiLanguageFlag) {
            <hr/>
          }
          @if (aiLanguageFlag && (loading$ | async) === false) {
            <div class="section-container transcript-container">
              <div>
                <strong>{{ 'feedback-session-feedback-display_transcript-header' | translate }}</strong>
              </div>
              <span class="transcript-language">
                <mat-form-field goSelect>
                  <mat-label>{{ 'activity-editor-new_ai-markers-modal-transcript-language' | translate }}</mat-label>
                  <mat-select
                    disableOptionCentering
                    panelClass="offsetPanel"
                    [ngModel]="selectedLanguage$ | async"
                    (ngModelChange)="selectedLanguage$.next($event)">
                    @for (language of languages$ | async; track language) {
                      <mat-option
                        [value]="language">
                        {{ language.language_name }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
                </mat-form-field>
              </span>
            </div>
          }
          @if ((loading$ | async) === false) {
            <div class="section-container markers-container"
              [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit}">
              <div class="container-header">
                <strong id="ai-markers-config-heading" class="ai-markers-header">{{ 'activity-editor-new_ai-markers-modal-ai-markers' | translate }}</strong>
                @if ((useTypes$ | async) && (showAi$ | async)) {
                  <div class="use-types-container">
                    <mat-form-field goSelect>
                      <mat-label>{{ 'activity-editor-new_ai-markers-modal-use-type' | translate }}</mat-label>
                      <mat-select
                        disableOptionCentering
                        panelClass="offsetPanel ai-marker-use-type-panel"
                        [ngModel]="useTypeFilter$ | async"
                        (selectionChange)="useTypeFilter$.next($event.value)">
                        @for (u of useTypes$ | async; track u) {
                          <mat-option
                            [value]="u.use_type_id">
                            {{ u.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
                    </mat-form-field>
                    @if ((selectedCount$ | async) > 0) {
                      <span class="selected-count"
                      role="img"
                      [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit }"
                      [attr.aria-label]="selectedCountAriaLabel((selectedCount$ | async))">({{ selectedCount$ | async }})</span>
                    }
                  </div>
                }
              </div>
              <div class="container-body">
                <div class="description-container">
                  <p translate="activity-editor-new_ai-markers-modal-description"
                    [translateParams]="{ limit: AiMarkersLimit }">
                  </p>
                  <div *teaseWall="toggleTeaseConfig; of: loading$">
                    <mat-slide-toggle
                      [hideIcon]="true"
                      (change)="toggleAiMarkers($event)"
                      [checked]="true"
                      aria-labelledby="ai-markers-config-heading"
                      [goAriaPressed]="(showAi$ | async)"
                      color="primary"
                      class="ai-comments-toggle">
                      @if (showAi$ | async) {
                        <span>{{ 'common_on' | translate }}</span>
                      }
                      @if ((showAi$ | async) === false) {
                        <span>{{ 'common_off' | translate }}</span>
                      }
                    </mat-slide-toggle>
                  </div>
                </div>
                @if (showAi$ | async) {
                  @for (category of uniqueCategories$ | async; track category) {
                    <div class="category-accordion" [ngClass]="{'expanded': (expandedCategories$ | async).has(category.id)}">
                      <div
                        class="category-accordion-header"
                        role="button"
                        tabindex="0"
                        [attr.id]="'ai-marker-category-header-' + category.id"
                        [attr.aria-expanded]="(expandedCategories$ | async).has(category.id)"
                        [attr.aria-controls]="'ai-marker-category-content-' + category.id"
                        (click)="toggleCategory(category)"
                        (keydown)="handleCategoryHeaderKeydown($event, category)">
                        <div class="category-header-left">
                          <div class="accordion-caret">
                            <i [ngClass]="{'ficon-app-chevron-down': (expandedCategories$ | async).has(category.id), 'ficon-app-chevron-right': !(expandedCategories$ | async).has(category.id)}"></i>
                          </div>
                          <span class="category-icon">
                            <i
                              [attr.data-icon]="category.icon"
														[ngStyle]="{
															'color': getCategoryColor(category.color),
															'--icon-content': '\'\\' + (category.icon) + '\''
														}"></i>
                          </span>
                          <span class="category-name">{{category.name}}</span>
                        </div>
                        <div class="category-header-right">
                          @if ((expandedCategories$ | async).has(category.id) && !shouldTease) {
                            <button
                              class="link-btn select-all-btn"
                              [translate]="(isAllSelectedInCategory(category) | async) ? 'library-collections_multi-select-none' : 'library-collections_multi-select-all'"
                              (keydown)="handleSelectCategoryPromptsKeydown($event)"
                              (click)="selectCategoryPrompts($event, category)">
                            </button>
                          }
                          @if (countByCategory$(category) | async; as categoryCount) {
                            @if (categoryCount > 0) {
                              <span class="category-count"
                                role="img"
                                [attr.aria-label]="categoryCountAriaLabel(categoryCount)">{{ categoryCount }}</span>
                            }
                          }
                        </div>
                      </div>
                      @if ((expandedCategories$ | async).has(category.id)) {
                        <div
                          class="category-accordion-content"
                          [attr.id]="'ai-marker-category-content-' + category.id"
                          [attr.aria-labelledby]="'ai-marker-category-header-' + category.id">
                          <fieldset class="markers ai-marker-prompts-fieldset">
                            <legend class="cdk-visually-hidden">{{ category.name }}</legend>
                            @for (prompt of getPromptsByCategory(category) | async; track prompt) {
                              <div class="marker-item">
                                @if (!shouldTease) {
                                  <div class="marker-item-row">
                                    <mat-checkbox
                                      color="primary"
                                      class="marker-checkbox new-checkbox"
                                      [checked]="(checkedIds$ | async).has(prompt.id)"
                                      (change)="selectPrompt($event.checked, prompt)"
                                      (keydown)="handlePromptCheckboxKeydown($event)"
                                      aria-label="{{ markerCheckboxAriaLabel(prompt) }}">
                                      <marker
                                        [marker]="markerInput(prompt)"
                                        [aiStyle]="true"
                                        [withName]="true">
                                      </marker>
                                    </mat-checkbox>
                                    @if (prompt.description) {
                                      <div class="prompt-description">
                                        <button
                                          type="button"
                                          mat-icon-button
                                          class="prompt-description-btn"
                                          [matTooltip]="prompt.description"
                                          matTooltipPosition="above"
                                          [attr.aria-label]="promptDescriptionButtonAriaLabel(prompt)">
                                          <mat-icon class="ficon-app-information-outline" aria-hidden="true"></mat-icon>
                                        </button>
                                      </div>
                                    }
                                  </div>
                                }
                                @if (shouldTease) {
                                  <div class="teased-marker-item">
                                    <div *teaseWall="checkboxTeaseConfig; of: loading$">
                                      <mat-checkbox
                                        color="primary"
                                        class="checkbox-to-blur"
                                        [checked]="(checkedIds$ | async).has(prompt.id)"
                                        [disabled]="true"
                                        aria-label="{{ markerCheckboxAriaLabel(prompt) }}">
                                      </mat-checkbox>
                                    </div>
                                    <div class="marker-and-description">
                                      <marker
                                        [marker]="markerInput(prompt)"
                                        [aiStyle]="true"
                                        [withName]="true">
                                      </marker>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </fieldset>
                        </div>
                      }
                    </div>
                  }
                  @if (!shouldTease) {
                    <div class="ai-marker-form-link">
                      <span>
                        <i class="ficon-lightbulb-o"></i>
                        {{ 'activity-editor-new_ai-markers-modal-request-feedback-text' | translate }}
                        <a
                          href="https://forms.office.com/Pages/ResponsePage.aspx?id=pc7Ek96TuEyKKMAbn5USrIoKGA0eaHdEmMM7pLelNidUOVIwV1NKRlE3TFIxWVI1QTA1OVJROUg3Ni4u"
                          target="_blank" rel="noopener noreferrer"
                          class="link-btn"
                          attr.aria-label="{{'activity-editor-new_ai-markers-modal-request-feedback-link'| translate}}"
                          translate="activity-editor-new_ai-markers-modal-request-feedback-link">
                        </a>
                      </span>
                    </div>
                  }
                }
              </div>
            </div>
          } @else {
            <span class="loading-container">
              <span class="ficon-spinner ficon-spin" aria-live="polite"
              attr.aria-label="{{'common_loading'| translate}}"></span>
            </span>
          }
          @if ((selectedCount$ | async) > AiMarkersLimit) {
            <div class="validation-error"
              translate="activity-editor-new_ai-markers-modal-validation-max_limit"
              [translateParams]="{ limit: AiMarkersLimit }">
            </div>
          }
        </div>
      }
      <div class="goreact-modal-footer">
        @if (shouldTease) {
          <a
            [attr.href]="aiMarkerTeaseConfig.secondaryLink"
            target="_blank"
            rel="noopener noreferrer"
            class="link-btn learn-more-link">
            {{ 'access_denied-learn-more' | translate }}
          </a>
        }
        <button class="tertiary-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
        <!-- We want to trigger the tease wall button using another button,
        so hide this tease wall button while still keeping it on the DOM -->
        @if (shouldTease) {
          <div *teaseWall="aiMarkerTeaseConfig" style="display: none;"></div>
        }
        @if (!shouldTease || aiMarkerTeaseConfig.promptAction) {
          <button class="primary-btn save-btn" (click)="handleSaveClick()">
            {{ shouldTease ? (aiMarkerTeaseConfig.translationKey | translate) : ('common_save-and-close' | translate) }}
          </button>
        }
      </div>
    </section>
  </div>
</div>
